import { MapTo } from '@adobe/aem-react-editable-components';
import AdobeModeTrigger, { AdobeModeTriggerEditConfig } from '../AdobeModeTrigger/AdobeModeTrigger';

export default MapTo('cob-corp-acquisition/components/creditonebank/adobe-mode-trigger')(AdobeModeTrigger, AdobeModeTriggerEditConfig);